<template>
  <div>
    <div class="mb-4 text-headline-xs">{{ t('Reviews.product.review.history.title') }}</div>
    <ReminderItem v-for="reminder in reminders" :key="reminder.createdAt" :author-name="authorName" :reminder="reminder" class="mb-4" />
  </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import ReminderItem from './ReminderItem.vue'
import type { SurveyResponseReminder } from './types'

defineProps<{
  authorName?: string
  reminders: SurveyResponseReminder[]
}>()

const { t } = useI18n()
</script>
